import { useEffect, useState } from 'react';
import styles from './Skeleton.module.scss';
import SkeletonElement from './SkeletonElement';
import Shimmer from './Shimmer';

export default function SkeletonTextHeader() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
    }, 200); // delay before showing the skeleton

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      className={styles.wrapper}
      style={{
        opacity: show ? 1 : 0,
        transition: 'opacity 200ms ease-in-out',
      }}
    >
      <div className={styles.textHeader}>
        <SkeletonElement type="headerIcon" />
        <SkeletonElement type="headerText" />
      </div>
      <Shimmer />
    </div>
  );
}
